import type { ReactNode } from 'react';
import { Children } from 'react';
import { Trigger } from '@radix-ui/react-collapsible';
import { styled } from 'styled-components';

export type CollapsibleTriggerProps = {
  /**
   * A trigger element that will toggle the collapsible content.
   * Usually a [Button](?path=/docs/components-button--docs).
   */
  children: ReactNode;
};

const StyledTrigger = styled(Trigger)`
  [data-wui-collapsible-icon] {
    transition: transform var(--wui-motion-duration-03) ease-in-out;
  }

  &[aria-expanded='true'] {
    [data-wui-collapsible-icon] {
      &[data-wui-collapsible-icon-rotate='90'] {
        transform: rotate(90deg);
      }

      &[data-wui-collapsible-icon-rotate='-90'] {
        transform: rotate(-90deg);
      }

      &[data-wui-collapsible-icon-rotate='45'] {
        transform: rotate(45deg);
      }
    }
  }
`;

export const CollapsibleTrigger = ({ children }: CollapsibleTriggerProps) => {
  Children.only(children); // eslint-disable-line @typescript-eslint/no-floating-promises
  return <StyledTrigger asChild={true}>{children}</StyledTrigger>;
};
